import { render, staticRenderFns } from "./ZapisSpecialistCard.vue?vue&type=template&id=59519910&scoped=true&"
import script from "./ZapisSpecialistCard.vue?vue&type=script&lang=js&"
export * from "./ZapisSpecialistCard.vue?vue&type=script&lang=js&"
import style0 from "./ZapisSpecialistCard.vue?vue&type=style&index=0&id=59519910&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59519910",
  null
  
)

export default component.exports